// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EDeinQzfS2N2rVW_Z1GP{width:20vw;padding:.5rem;position:relative}.EDeinQzfS2N2rVW_Z1GP .yKZwcRZ95X45OhZYOwuY{filter:invert(100%)}.EDeinQzfS2N2rVW_Z1GP:hover{cursor:pointer}`, "",{"version":3,"sources":["webpack://./src/components/Logo/Logo.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CACA,aAAA,CACA,iBAAA,CACA,4CACE,mBAAA,CAGJ,4BACE,cAAA","sourcesContent":[".Logo {\n  width: 20vw;\n  padding: 0.5rem;\n  position: relative;\n  .whiteLogo {\n    filter: invert(100%);\n  }\n}\n.Logo:hover {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Logo": `EDeinQzfS2N2rVW_Z1GP`,
	"whiteLogo": `yKZwcRZ95X45OhZYOwuY`
};
export default ___CSS_LOADER_EXPORT___;
